import { DeleteForever } from '@mui/icons-material';
import { ListItemButton, ListItemText } from '@mui/material';
import { ActionMenu, DocumentOutlined } from '@side/pantry';

export const BuyerAgreementFile = ({
  file,
  deleteFile,
}: {
  file: File;
  deleteFile: (file: File) => void;
}) => {
  const url = URL.createObjectURL(file);
  const lastPeriodIndex = file.name.lastIndexOf('.');
  const name =
    lastPeriodIndex >= 0 ? file.name.substring(0, lastPeriodIndex) : file.name;

  return (
    <ListItemButton
      onClick={() => {
        window.open(url);
      }}
    >
      <ListItemText
        primary={name}
        secondary={
          <>
            <DocumentOutlined />
            Signed Buyer Agreement
          </>
        }
      />
      <ActionMenu
        variant="borderless"
        title="File actions menu"
        options={[
          {
            label: 'Delete',
            onClick: () => {
              deleteFile(file);
            },
            icon: <DeleteForever sx={{ color: 'error.main' }} />,
            labelColor: 'error',
          },
        ]}
      />
    </ListItemButton>
  );
};
